import { VehicleType } from './helpers';

export const getAdditionalZones = () => {
    return {
        windshield: {
            label: 'Forrude',
            value: 'forrude'
        },
        cabin: {
            label: 'Kabine',
            value: 'kabine'
        },
        rearWindow: {
            label: 'Bagrude',
            value: 'bagrude'
        },
        mechanicalParts: {
            label: 'Mekaniske dele',
            value: 'mekaniskeDele'
        },
        roof: {
            label: 'Tag',
            value: 'tag'
        },
        accessories: {
            label: 'Tilbehør',
            value: 'tilbehoer'
        },
        underCarriage: {
            label: 'Undervogn',
            value: 'undervogn'
        }
    };
};

export const getValueMappingToValueId = () => {
    return {
        front: '1',
        venstreFront: '3',
        hoejreFront: '2',
        venstreSide: '5',
        hoejreSide: '4',
        venstreBagende: '7',
        hoejreBagende: '6',
        bagende: '8',
        forrude: 'F',
        kabine: 'K',
        bagrude: 'B',
        mekaniskeDele: 'M',
        tag: '9',
        tilbehoer: 'T',
        undervogn: 'U'
    };
};

export const getAdditionalZonesMapping = () => {
    const zones = getAdditionalZones();

    const commonZones = [
        zones.windshield,
        zones.cabin,
        zones.rearWindow,
        zones.mechanicalParts,
        zones.roof,
        zones.accessories,
        zones.underCarriage
    ];

    const additionalZonesMap: Readonly<{ [key in VehicleType]?: { label: string; value: string }[] }> = {
        personbil: commonZones,
        knallert: [zones.windshield, zones.cabin, zones.mechanicalParts, zones.accessories, zones.underCarriage],
        trailer: [zones.mechanicalParts, zones.roof, zones.accessories, zones.underCarriage],
        campingvgn: commonZones,
        varevogn: commonZones,
        bus: commonZones,
        gaffeltruck: commonZones,
        traktor: commonZones,
        lastbil: commonZones
    };

    return additionalZonesMap;
};
